import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { DateAdapter } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LocationService } from "./shared/location.service";

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {

  AddButtonText: string = "Save";
  ErrorText: string;
  dataSourceList = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ParentLocationId: number;
  LocationList: [''];

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
     public locationService: LocationService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(param => {
      this.ParentLocationId = + param['Id'];  //Parent Location Id
    });

    this.resetForm();
    this.GetLocation();    

    this.dataSourceList.paginator = this.paginator;

    if (Number.isNaN(this.ParentLocationId)) {
      this.locationService.selectedLocation.Id = 0;
      this.locationService.selectedLocation.Flag = 1;
      this.locationService.selectedLocation.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.locationService.selectedLocation.Id = +this.ParentLocationId;
      // this.locationService.selectedLocation.Flag = 2;
      // this.locationService.selectedLocation.IsActive = 1;
      this.AddButtonText = "Edit & Save";

      this.GetLocationByLocationId();   
    }  
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.locationService.selectedLocation = {
      Id: 0,
      LocationId: 0,
      LocationName: null,
      LocationType: null,
      EmployeeId: null,
      BranchId: null,
      CompanyId: null,
      SaasId: null,
      IsActive: true,
      Flag: 0,
    }
  }

  public onSubmit(form: NgForm) {
    this.locationService.IUDLocation(form.value)
      .subscribe(data => {
        this.resetForm(form);
        this.router.navigate(['/locationlist']);
      })
  }


  GetLocation(){
    this.locationService.GetLocation().subscribe(data => {
      this.LocationList = data;
    })
  }

  GetLocationByLocationId() {

    if (!Number.isNaN(this.ParentLocationId)) {
      this.locationService.selectedLocation.LocationId = this.ParentLocationId;
      this.locationService.FetchLocationByLocationId(this.locationService.selectedLocation).subscribe(data => {

        this.locationService.selectedLocation =data;
        // this.locationService.selectedLocation.Id = +data.Id;
        this.locationService.selectedLocation.Flag = 2;

      })
    }
  }

}
